//====================================
// Remove slider if it is already on page
//==================================== 
export function removeSlider(slider) {
	if ($(slider).hasClass('slick-initialized')) {
		$(slider).slick('unslick');
	}
}